export default __webpack_public_path__ + "static/media/test.3184d875.pdf";